module.exports = __webpack_public_path__ + "assets/campaign/img/logo-pow.9d47c6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-pow.png
// module id = oiYT
// module chunks = 1